module.exports = __webpack_public_path__ + "static/media/maintain-icon.91d07fba.svg";